import React from "react";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import {Types} from "components";

import {Button} from "reactstrap";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import TransactionObject from "components/TransactionObject";
import moment from "moment";


/**
 *  @property {Dispositions_Pendings_Object} y
 *  @property {object} model
 *  @property {Dispositions_Pendings_Properties} model.properties
 *  @property {Dispositions_Pendings_Is} model.is
 *  @property {Dispositions_Pendings_Has} model.has
 */
export default class DispositionPending extends TransactionObject {
	constructor(props) {
		super(props, Types.Dispositions_Pendings._name);
		this.model.properties.location.required = true;

		this.afterEventSave = this.setNewObject('event');
		this.state.transaction_purposes = "";
	}

	formatRace = () => {
		let formattedRace = ""
		if (this.state.race_asian === true) {
			if (
				this.state.race_american_indian === true ||
				this.state.race_african_american === true ||
				this.state.race_native_hawaiian === true ||
				this.state.race_white === true
			) {
				formattedRace += "Asian, "
			}
			else {
				formattedRace += "Asian"
			}
		}

		if (this.state.race_american_indian === true) {
			if (
				this.state.race_african_american === true ||
				this.state.race_native_hawaiian === true ||
				this.state.race_white === true
			) {
				formattedRace += "American Indian or Alaskan Native, "
			}
			else {
				formattedRace += "American Indian or Alaskan Native"
			}
		}

		if (this.state.race_african_american === true) {
			if (
				this.state.race_native_hawaiian === true ||
				this.state.race_white === true
			) {
				formattedRace += "Black or African American, "
			}
			else {
				formattedRace += "Black or African American"
			}
		}

		if (this.state.race_native_hawaiian === true) {
			if (this.state.race_white === true) {
				formattedRace += "Native Hawaiian or Other Pacific Islander, "
			}
			else {
				formattedRace += "Native Hawaiian or Other Pacific Islander"
			}
		}

		if (this.state.race_white === true) {
				formattedRace += "White"
		}

		return formattedRace
	}

	/**
	 *l
	 * @param data
	 * @returns {Promise<void>}
	 */
	async loadSelfAfter(data) {
		let inches = data.height_in ? data.height_in.toString() : null;
		if (inches !== null && inches.length === 1) {
			inches = '0' + inches.toString();
			this.setState({height_in: inches});
		}
		if(inches !== null){
			this.state.height = this.state.height_ft + inches;
		} else {
			this.state.height = this.state.height_ft + "00";
		}
		if(localStorage.getItem('transaction_purposes')) {
			this.state.transaction_purposes = localStorage.getItem('transaction_purposes');
		}

	}


	handleProcess(event, requestOverride) {
		let result = true;
		if (this.update === 'POST_COMPLETE') {
			if (this.state.disposition_pending_itemss === null || this.state.disposition_pending_itemss.length === 0) {
				API.Toast.warn('Product is required.', {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 4000
				});
				result = false;
			}
		}

		//If either is false then fail
		//Skip Transaction Object handleProcess
		if (event === null) event = {};
		event.bypassSelf = true;
		return result && super.handleProcess(event, requestOverride);
	}



	randomHash = async (length) => {
			let result = '';
			const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			const charactersLength = characters.length;
			let counter = 0;
			while (counter < length) {
				result += characters.charAt(Math.floor(Math.random() * charactersLength));
				counter += 1;
			}
			return result;

	}


	// handleLeepLogin = async () => {
	// 	let leepLogModel = new API.BuildClass(Types.Leep_User_Logs._name, API.RequestType.CREATE);
	// 	this.state.ethnicity = this.state.ethnicity_hispanic ? "Is Hispanic or Latino" : "Is Not Hispanic or Latino";
	// 	this.state.race = this.state.formattedRace;
	// 	this.state.citizenship_status = this.state.foreign_citizenship ? "Non-U.S. Citizen" : "US Citizen";
	// 	this.state.height = this.state.height_ft + this.state.height_in.toString();
	//
	// 	let pending_hash = this.randomHash(16);
	// 	this.state.pending_hash = pending_hash;
	// 	localStorage.setItem('leep_hash', pending_hash);
	// 	await leepLogModel.submit(this, API.RequestType.CREATE, true);
	// }

	addToClipboard(text) {
		if (text !== null && text !== undefined) {
			navigator.clipboard.writeText(text).catch(e => console.log(e.message));
		}
	}

	addDateToClipboard(date) {
		let day = date.split('-')[2];
		let month = date.split('-')[1];
		let year = date.split('-')[0];
		this.addToClipboard(`${month}/${day}/${year}`);
	}
	/**
	 * Return TRUE to prevent handleSubmit from running afterSave(data) if already ran in the override here.
	 * @param data
	 * @param request
	 * @param suppressProcess
	 * @returns {Promise<void>}
	 */
	async afterSubmit(data, request, suppressProcess = false) {
		this.props.history.push('/dispositions/pendings/' + data.binary_id + '-' + data.pkey);
	}


	form = () => {
		/** @type {Dispositions_Pendings_Properties} properties */
		let properties = this.model.properties;
		/** @type {Dispositions_Pendings_Object} object */
		let object = this.state;
		let {loading} = this.state;
		let birth_date = moment(object.birth_date).format('MM/DD/YYYY');
		let formattedRace = this.formatRace();
		this.state.formattedRace = formattedRace;
		if(this.state.nics_date === null) {
			this.setState({nics_date: moment().local().format("YYYY-MM-DD HH:mm:ss")})
		}
		// this.loadSelfAfter(object);
		return (
			<div>
				<fieldset>

					<h4 className="section-title">NICS (or State POC)</h4>

					<div className={'row'}>
						<div className={'col-8'}>
							<p id="manual-instructions" style={{textAlign: 'center'}}>
								<b>1)</b> Chrome v91 disables the ability to change same site cookie restrictions.<br/>
								<b>2)</b> Click the Launch LEEP button to open LEEP in a new tab.<br/>
								<b>3)</b> Copy each field and paste into the LEEP
								system.<br/>
								<b>4)</b> Select the appropriate response at the top of the page after receiving a response.<br/>
								or<br/>
								Download the <a
								href="https://chrome.google.com/webstore/detail/ffl-boss-enics-autofill/gkcaldngjihkfdllegnaniclnpdfcaid"
								target="_blank">FFL Boss Chrome Extension</a> for two click background check automation.
							</p>
							<p id="automated-instructions" style={{textAlign: 'center', display: 'none'}}>
								<b>1)</b> Chrome v91 disables the ability to change same site cookie restrictions.<br/>
								<b>2)</b> Click the Launch LEEP button to open LEEP in a new tab.<br/>
								<b>3)</b> Store your LEEP login information in your FFL Boss user account settings to be signed in automatically.<br/>
								<b>4)</b> Answer the security questions if asked.<br/>
								<b>5)</b> Click "Submit a Search Request" and the information will be auto populated for you.<br/>
								<b>6)</b> Select the appropriate response at the top of the page after receiving a response.
							</p>
						</div>
						<div className={'col-4'}>

							<div className={'form-group'}>
								<p style={{fontSize: '11px'}}>
									The response initially (first) provided by NICS or the appropriate State agency was:
								</p>
							</div>
							<div className={"row"}>
								<div className={"col-sm"}>
									<div className="form-group">
										<Framework.Elements.Date
											label={"Response Date"}
											property={properties.nics_date}
											value={object.nics_date}
											error={object.nics_date_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
								<div className={"col-sm"}>
									<div className="form-group">
										<Framework.Elements.TextField
											label={'Number'}
											property={properties.nics_number}
											value={object.nics_number}
											error={object.nics_number_error}
											update={this.handleTextFieldPropertyUpdate}
										/>
									</div>
								</div>
							</div>
							<div className={'form-group'}>

								<Framework.Elements.Select
									shouldLoad={true}
									update={this.handleSelectPropertyUpdate}
									property={properties.nics_response}
									value={object.nics_response}
									error={object.nics_response_error}

									model={Types.Nics_Responses._name}
									id={'name'}
									label={"NICS Response"}
									nullable={true}
									limit={null}
								/>

							</div>

							<Button color="primary" className={"pull-right"} onClick={this.handleSubmit}>Save</Button>

						</div>
					</div>

					<hr/>
					<div className="row">
						<div className="col-12">
							<Card>
								<CardContent>
									<div style={{textAlign: 'center'}}>
										<a target={'_blank'} href={'https://www.cjis.gov/nics/PRServletSSO'}>
										<Button color="primary"
										// onClick={this.handleLeepLogin}
										>Launch Assisted LEEP</Button>
										</a>
									</div>
									<CardHeader
										title="Click on a field to copy to clipboard"
										style={{textAlign: 'center'}}
									/>
									<h4 className="section-title">Number 9</h4>
									<fieldset disabled={true}>
									<div className="row">
										<div className="col" onClick={() => {this.addToClipboard(this.state.name_first)}}>
											<Framework.Elements.TextField
												label={'First Name'}
												property={properties.name_first}
												value={object.name_first}
												error={object.name_first_error}
											/>
										</div>

										<div className="col" onClick={() => {this.addToClipboard(this.state.name_middle)}}>
												<Framework.Elements.TextField
													label={'Middle Name'}
													property={properties.name_middle}
													value={object.name_middle ? object.name_middle : 'NMN'}
													error={object.name_middle_error}
												/>
										</div>

										<div className="col" onClick={() => {this.addToClipboard(this.state.name_last)}}>
												<Framework.Elements.TextField
													label={'Last Name'}
													property={properties.name_last}
													value={object.name_last}
													error={object.name_last_error}
												/>
										</div>

										<div className="col-2" onClick={() => {this.addToClipboard(this.state.name_suffix)}}>
												<Framework.Elements.TextField
													label={'Suffix'}
													property={properties.name_suffix}
													value={object.name_suffix}
													error={object.name_suffix_error}
												/>
										</div>
									</div>
								</fieldset>
								</CardContent>

								<CardContent>
									<h4 className="section-title">Numbers 10 - 13</h4>
									<fieldset disabled={true}>
										<div className="row">
											<div className="col-3" onClick={() => {this.addToClipboard(this.state.state_of_residence)}}>
													<Framework.Elements.TextField
														label={'State of Residence'}
														property={properties.state_of_residence}
														value={object.state_of_residence}
														error={object.state_of_residence_error}
													/>
											</div>

											<div className="col" onClick={() => {this.addToClipboard(object.birth_country ?
												object.birth_country : object.birth_state)}}>
													<Framework.Elements.TextField
														label={'Place of Birth'}
														property={object.us_born ? properties.birth_state : properties.birth_country}
														value={object.us_born ? object.birth_state : object.birth_country}
														error={object.us_born ? object.birth_state_error : object.birth_country_error}
													/>
											</div>

											<div className="col-2" onClick={() => {this.addToClipboard(String(this.state.height))}}>
													<Framework.Elements.TextField
														label={'Height'}
														property={properties.height_in}
														value={this.state.height}
														error={object.height_in_error}
													/>
											</div>

											<div className="col-2" onClick={() => {this.addToClipboard(this.state.weight)}}>
												<Framework.Elements.TextField
													label={'Weight'}
													property={properties.weight}
													value={object.weight}
													error={object.weight_error}
												/>
											</div>
										</div>
									</fieldset>
								</CardContent>

								<CardContent>
									<h4 className="section-title">Numbers 14 - 17</h4>
									<fieldset disabled={true}>
										<div className="row">
											<div className="col-3" onClick={() => {this.addToClipboard(this.state.gender === "M" ?
												"Male" : this.state.gender === "F" ? "Female" : "Non-Binary")}}>
													<Framework.Elements.TextField
														label={'Sex'}
														property={properties.gender}
														value={this.state.gender === "M" ?
															"Male" : this.state.gender === "F" ? "Female" : "Non-Binary"}
														error={object.gender_error}
													/>
											</div>

											<div className="col" onClick={() => {this.addToClipboard(birth_date ? birth_date : null)}}>
													<Framework.Elements.TextField
														label={'Birth Date'}
														property={properties.birth_date}
														value={birth_date ? birth_date : ""}
														error={object.birth_date_error}
													/>
											</div>

											<div className="col" onClick={() => {this.addToClipboard(this.state.ssn ? this.state.ssn : null)}}>
													<Framework.Elements.TextField
														label={'SSN'}
														property={properties.ssn}
														value={object.ssn}
														error={object.ssn_error}
													/>
											</div>

											<div className="col" onClick={() => {this.addToClipboard(this.state.upin ? this.state.upin : null)}}>
													<Framework.Elements.TextField
														label={'UPIN / AMD ID'}
														property={properties.upin}
														value={object.upin ? object.upin : "N/A"}
														error={object.upin_error}
													/>
												</div>
										</div>
									</fieldset>
								</CardContent>

								<CardContent>
									<h4 className="section-title">Number 18 a/b</h4>
									<fieldset disabled={true}>
										<div className="row">
											<div className="col" onClick={() => {this.addToClipboard(this.state.ethnicity_hispanic ?
												"Is Hispanic or Latino" : "Is Not Hispanic or Latino")}}>
													<Framework.Elements.TextField
														label={'Ethnicity'}
														property={properties.ethnicity_hispanic}
														value={this.state.ethnicity_hispanic ?
															"Is Hispanic or Latino" : "Is Not Hispanic or Latino"}
														error={object.ethnicity_hispanic_error}
													/>
											</div>

											<div className="col" onClick={() => {this.addToClipboard(formattedRace)}}>
													<Framework.Elements.TextField
														label={'Race'}
														property={properties.race_african_american}
														value={formattedRace}
														error={object.race_african_american_error}
													/>
											</div>
										</div>
									</fieldset>
								</CardContent>

								<CardContent>
									<h4 className="section-title">Number 19</h4>
									<fieldset disabled={true}>
										<div className="row">
											<div className="col" onClick={() => {this.addToClipboard(object.foreign_citizenship ?
												"Non-U.S. Citizen" : "U.S. Citizen")}}>
													<Framework.Elements.TextField
														label={'Citizenship Status'}
														property={properties.us_citizen}
														value={object.us_citizen ? "U.S. Citizen" : "Non-U.S. Citizen"}
														error={object.us_citizen_error}
													/>
											</div>

											<div className="col" onClick={() => {this.addToClipboard(object.birth_country ? object.birth_country : null)}}>
													<Framework.Elements.TextField
														label={object.us_citizen ? 'State of Residence' : 'Country of Residence'}
														property={object.us_citizen ? properties.state_of_residence : properties.foreign_citizenship}
														value={object.us_citizen ? object.state_of_residence : object.foreign_citizenship}
														error={object.us_citizen ? object.us_citizen_error : object.foreign_citizenship_error}
													/>
											</div>
										</div>
									</fieldset>
								</CardContent>

								<CardContent>
									<h4 className="section-title">Numbers 20 - 26</h4>
									<fieldset disabled={true}>
										<div className="row">
											<div className="col" onClick={() => {this.addToClipboard(this.state.identification_authority)}}>
													<Framework.Elements.TextField
														label={object.identification_authority ? 'Identification Authority' : "No ID Authority"}
														property={properties.identification_authority}
														value={object.identification_authority}
														error={object.identification_authority_error}
													/>
											</div>

											<div className="col" onClick={() => {this.addToClipboard(object.identification_number)}}>
													<Framework.Elements.TextField
														label={object.identification_type ? `ID Type - ${object.identification_type}` : "No Identification"}
														property={properties.identification_number}
														value={object.identification_number}
														error={object.identification_number_error}
													/>
											</div>

											<div className="col" onClick={() => {this.addToClipboard(object.nonimmigrant_visa ? "True" : "False")}}>
												<Framework.Elements.TextField
													label={'Non-Immigrant Visa'}
													property={properties.nonimmigrant_visa}
													value={object.nonimmigrant_visa ? "True: " + object.alien_number : "False"}
													error={object.nonimmigrant_visa_error}
												/>
											</div>
										</div>
									</fieldset>
								</CardContent>

								<CardContent>
									<h4 className="section-title">Number 24</h4>
									<fieldset disabled={true}>
										<div className="row">
											<div className="col" onClick={() => {this.addToClipboard(this.state.transaction_purposes.substring(1, this.state.transaction_purposes.length-1))}}>
												<Framework.Elements.TextField
													label={'Transaction Purposes'}
													property={properties.transaction_purposes}
													value={object.transaction_purposes}
													error={object.transaction_purposes_error}
													multiline={2}
												/>
											</div>
										</div>
									</fieldset>
								</CardContent>

							</Card>
						</div>
					{/*	<div className="col-7">*/}
					{/*<iframe id="enics" src="https://www.cjis.gov/CJISEAI/EAIController"*/}
					{/*        style={{minWidth: '825px', border: 'none', overflow: 'scroll'}} width="100%" height="1000" scrolling="yes"*/}
					{/*        frameBorder="0"/>*/}
					{/*	</div>*/}
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

	render() {
		let hasModal = typeof this.props.hasModal !== 'undefined' ? this.props.hasModal : false;
		if (hasModal) {
			return this.form();
		}
		return (
			<Card>
				<CardContent>
					{this.form()}
				</CardContent>
			</Card>
		)
	}
}
